<template>
  <div id="RecentNotify">
    <v-data-table
      dense
      :headers="headers"
      :items="notify"
      sort-by="Status"
      class="elevation-1"
    ></v-data-table>
  </div>
</template>

<script>
import api from "../api";
const moment = require("moment");
export default {
  name: "RecentNotify",
  data() {
    return {
      notify: [],
      headers: [{
        text: 'From',
        width: 150,
        value: 'fromname'
      },{
        text: 'To',
        width: 150,
        value: 'username'
      },{
        text: 'Title',
        value: 'title'
      },{
        text: 'Text',
        value: 'text'
      },{
        text: 'Updated',
        width: 200,
        value: 'modify'
      },{
        text: 'Status',
        value: 'status'
      }]
    };
  },
  mounted(){
    this.getRecentNotify()
  },
  computed: {},
  methods: {
    getRecentNotify() {
      var me = this
      api.getRecentNotify(function (res) {
        let data = JSON.parse(JSON.stringify(res.data))
        data.forEach(function (el) {
          el.modify = moment.utc(el.modify).local().format('MM/DD/YYYY hh:mm A')
        })
        return me.notify = data
      },me)
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>